import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-233">
      <div className="max-w-2xl mx-auto text-center" data-id="element-234">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-235">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#00B4D8] mb-4" data-id="element-236">
          GARANTÍA PROFEPACK™ — 7 DÍAS
        </h2>

        <div className="bg-[#000d1a] border-2 border-[#00B4D8] rounded-2xl p-8 mb-6" data-id="element-237">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-238">
            Abrís los 6 tomos. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-239">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00B4D8] text-3xl font-black mb-4" data-id="element-240">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-241">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-242">
          La confianza que tenemos en el MegaPack Francés Listo nos permite
          hacer esa promesa sin dudar.
          <br data-id="element-243" />
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}